import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '@env/environment';

export interface SubscriptionPlan {
    id: number;
    name: string;
    billingInterval: 'free' | 'monthly' | 'quarterly' | 'semiAnnual' | 'annual' | 'lifetime';
    price: number;
    currency: string;
    isFree: boolean;
    isLifetime: boolean;
}

export interface LmsSubscription {
    id: number;
    status: 'pending' | 'trial' | 'active' | 'pastDue' | 'cancelled' | 'expired';
    cancelAtPeriodEnd: boolean;
    plan: SubscriptionPlan;
    currentPeriodStart: string | null;
    currentPeriodEnd: string | null;
    nextPaymentDate: string | null;
    cancelledAt: string | null;
    trialEndsAt: string | null;
    gateway: string | null;
}

@Injectable({ providedIn: 'root' })
export class SubscriptionLearnerService {
    private readonly baseUrl: string;

    constructor(private http: HttpClient) {
        const apiUrl = environment.envVar.API_URL.endsWith('/')
            ? environment.envVar.API_URL.slice(0, -1)
            : environment.envVar.API_URL;
        this.baseUrl = `${apiUrl}/subscriptions`;
    }

    getMySubscription(): Observable<LmsSubscription | null> {
        return this.http.get<any>(`${this.baseUrl}/my-subscription`).pipe(
            map(res => res?.data ?? res ?? null),
            catchError(err => {
                if (err.status === 404) {
                    return of(null);
                }
                throw err;
            })
        );
    }

    cancelSubscription(subscriptionId: number, reason?: string): Observable<void> {
        const body: any = { subscriptionId };
        if (reason) {
            body.cancellationReason = reason;
        }
        return this.http.delete<void>(`${this.baseUrl}/cancel`, { body });
    }
}
